import { gql } from '@apollo/client'

//Lookup Queries
export const GET_BOAT_TYPE = gql`
    query BoatType($code: String) {
        boatType(code: $code) {
            code
            description {
                en
                ar
            }
        }
    }
`
export const GET_BOAT_AMENITIES = gql`
    query BoatFeaturesAmenities($code: String) {
        boatFeaturesAmenities(code: $code) {
            code
            description {
                en
                ar
            }
        }
    }
`
export const GET_BOAT_EQUIPMENTS = gql`
    query BoatSafetyEquipment($code: String) {
        boatSafetyEquipment(code: $code) {
            code
            description {
                en
                ar
            }
        }
    }
`
export const GET_BOAT_SEAT_LAYOUT = gql`
    query BoatSeatLayout($boatSeatLayoutId: String) {
        boatSeatLayout(id: $boatSeatLayoutId) {
            layout_id
            layout_key
            description {
                en
                ar
            }
        }
    }
`
export const GET_BOAT_STATUS = gql`
    query BoatStatus($code: String) {
        boatStatus(code: $code) {
            code
            description {
                en
                ar
            }
        }
    }
`
// Boat List Queries
export const SEARCH_BOAT_LIST = gql`
    query SearchBoat($searchBoatId: String, $name: String, $page: PageInput!, $statusCode: String) {
        searchBoat(id: $searchBoatId, name: $name, page: $page, status_code: $statusCode) {
            code
            success
            message
            total_count
            boats {
                id
                name {
                    en
                    ar
                }
                details {
                    reg_number
                    boat_type {
                        code
                        description {
                            en
                            ar
                        }
                    }
                    capacity
                    features_amenities {
                        code
                        description {
                            en
                            ar
                        }
                    }
                    images {
                        file_name
                        size
                        mime_type
                        s3_key
                    }
                }
                status {
                    code
                    description {
                        en
                        ar
                    }
                }
                weight_config {
                    capacity {
                        passengers
                        crew
                        captains
                    }
                    weight_standards {
                        passengers {
                            infant_kg
                            child_kg
                            adult_kg
                            senior_kg
                        }
                        default_luggage_kg
                    }
                    luggage_policy {
                        extra_luggage_options_kg
                        max_extra_luggage_total_kg
                    }
                    safety_limits {
                        max_passenger_weight_kg
                        max_load_kg
                    }
                    special_items_limits {
                        strollers
                        wheelchairs
                    }
                }
            }
        }
    }
`
export const SEARCH_BOAT_DETAILS = gql`
    query SearchBoat($searchBoatId: String, $name: String, $page: PageInput!, $statusCode: String) {
        searchBoat(id: $searchBoatId, name: $name, page: $page, status_code: $statusCode) {
            code
            success
            message
            total_count
            boats {
                id
                name {
                    en
                    ar
                }
                details {
                    reg_number
                    boat_type {
                        code
                        description {
                            en
                            ar
                        }
                    }
                    capacity
                    features_amenities {
                        code
                        description {
                            en
                            ar
                        }
                    }
                    safety_equipment {
                        code
                        description {
                            en
                            ar
                        }
                    }
                    description {
                        en
                        ar
                    }
                    images {
                        file_name
                        size
                        mime_type
                        s3_key
                    }
                }
                status {
                    code
                    description {
                        en
                        ar
                    }
                }
                seat_layout {
                    layout_id
                    layout_key
                    description {
                        en
                        ar
                    }
                }
                weight_config {
                    capacity {
                        passengers
                        crew
                        captains
                    }
                    weight_standards {
                        passengers {
                            infant_kg
                            child_kg
                            adult_kg
                            senior_kg
                        }
                        default_luggage_kg
                    }
                    luggage_policy {
                        extra_luggage_options_kg
                        max_extra_luggage_total_kg
                    }
                    safety_limits {
                        max_passenger_weight_kg
                        max_load_kg
                    }
                    special_items_limits {
                        strollers
                        wheelchairs
                    }
                }
            }
        }
    }
`
